import { combineReducers } from "@reduxjs/toolkit"
import { alertSlice } from "./alertStore"
import authSlice from "./authStore"
import { dateSlice } from "./dateStore"
import { menuSlice } from "./menuStore"
import { syaryoMasterSlice } from "./pageStore/syaryoMaster/syaryoMasterStore"
import { zyomuinKadoTyoseiSlice } from "./pageStore/zyomuinKyuyoStore/zyomuinKyuyoStore"
import { zyomuinMasterSlice } from "./pageStore/zyomuinMaster/zyomuinMasterStore"
import { progressSlice } from "./progressStore"
import { terminalSlice } from "./terminalStore"

const rootReducer = combineReducers({
  alert: alertSlice.reducer,
  terminal: terminalSlice.reducer,
  date: dateSlice.reducer,
  progress: progressSlice.reducer,
  menu: menuSlice.reducer,
  user: authSlice.reducer,
  page: combineReducers({
    syaryoMaster: syaryoMasterSlice.reducer,
    zyomuinMaster: zyomuinMasterSlice.reducer,
    zyomuinKadoTyosei: zyomuinKadoTyoseiSlice.reducer,
  }),
})

/**
 * store内のstate
 */
export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
